import { TAKE_PHOTO, GET_DIAGNOSIS, SELECT_CROP_TYPE } from "../assests/images";
import ClockIcon from "../assests/icons/ClockIcon";
import FlashIcon from "../assests/icons/FlashIcon";
import ExpertIcon from "../assests/icons/ExpertIcon";
import GraphIcon from "../assests/icons/GraphIcon";
import { useTranslation } from "react-i18next";

export const infoSteps = [
  {
    title: "take_a_photo",
    description: "take_a_photo_description",
    icon: TAKE_PHOTO,
  },
  {
    title: "select_crop_type",
    description: "select_crop_type_description",
    icon: SELECT_CROP_TYPE,
  },
  {
    title: "get_diagnosis",
    description: "get_diagnosis_description",
    icon: GET_DIAGNOSIS,
  },
];

export const benefits = [
  {
    title: "save_time_and_money",
    description: "save_time_and_money_description",
    icon: ClockIcon,
  },
  {
    title: "instant_diagnosis",
    description: "instant_diagnosis_description",
    icon: FlashIcon,
  },
  {
    title: "expert_advice",
    description: "expert_advice_description",
    icon: ExpertIcon,
  },
  {
    title: "improves_crop_yield_and_health",
    description: "improves_crop_yield_and_health_description",
    icon: GraphIcon,
  },
];
